import { LOGOUT } from 'common-src/features/auth/actionTypes';
import {
  CACHE_PATIENT,
  CACHE_PORTAL_INVITES,
  CACHE_PORTAL_RELATION_STATUSES,
  CACHE_PORTAL_THREAD_MESSAGES,
  CACHE_PORTAL_THREADS,
  SET_CLIENTS_CACHED,
  SET_ORGANIZATIONS_CACHED,
} from 'common-src/features/cache/actionTypes';
import { createReducer } from 'common-src/utils/reducerUtils';

const initialState = {
  isOrganizationsCached: false,
  isClientsCached: false,
  patients: {},
  taskEvents: {},
  portalThreads: {},
  portalThreadMessages: {},
  portalInvites: {},
  portalRelationStatuses: {},
};

const entityHandlers = {
  [SET_ORGANIZATIONS_CACHED]: (state, payload) => ({
    ...state,
    isOrganizationsCached: payload.isCached,
  }),
  [SET_CLIENTS_CACHED]: (state, payload) => ({
    ...state,
    isClientsCached: payload.isCached,
  }),
  [CACHE_PATIENT]: (state, { patientId, tab }) => ({
    ...state,
    patients: {
      ...state.patients,
      [patientId]: {
        ...state.patients[patientId],
        [tab]: true,
      },
    },
  }),
  [CACHE_PORTAL_INVITES]: (state, { portalPatientId, invites }) => ({
    ...state,
    portalInvites: {
      ...state.portalInvites,
      [portalPatientId]: invites,
    },
  }),
  [CACHE_PORTAL_THREADS]: (state, { patientId, threads }) => ({
    ...state,
    portalThreads: {
      ...state.portalThreads,
      [patientId]: threads,
    },
  }),
  [CACHE_PORTAL_THREAD_MESSAGES]: (state, { threadId, messages }) => ({
    ...state,
    portalThreadMessages: {
      ...state.portalThreadMessages,
      [threadId]: messages,
    },
  }),
  [CACHE_PORTAL_RELATION_STATUSES]: (state, { portalPatientId, relationStatuses }) => ({
    ...state,
    portalRelationStatuses: {
      ...state.portalRelationStatuses,
      [portalPatientId]: relationStatuses,
    },
  }),
  [LOGOUT]: () => initialState,
};

export const reducer = createReducer(initialState, entityHandlers);
